<template>
  <div class="stat-panel-container">
    <Tooltip :disabled="tooltip === ''" :content="tooltip" placement="top" max-width="600">
      <div :class="colorClass + ' stat-panel panel'">
        <Spin v-if="showLoading" fix />
        <div class="stat-banner">
          <div class="stat-count">
            <countTo
              ref="countTo"
              :suffix="suffix"
              :start-val="countStartValue"
              :end-val="countEndValue"
              :duration="duration"
              :decimals="decimals"
            />
          </div>
          <div class="stat-count-subtitle">
            {{ subTitle }}
          </div>
        </div>
        <div class="stat-icon">
          <Icon :type="iconType" />
        </div>
        <div class="stat-refresh">
          <Icon type="md-refresh" @click.stop="refreshStat()" />
        </div>
      </div>
    </Tooltip>
  </div>
</template>

<script>
import request from '@/utils/request'
import countTo from 'vue-count-to'
// import { getStat } from '@/api/apis'
import { Icon } from 'iview'
export default {
  name: 'CountPanel',
  components: { countTo, Icon },
  props: {
    url: {
      type: String,
      default: ''
    },
    suffix: {
      type: String,
      default: ''
    },
    decimals: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: true
    },
    colorClass: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 1500
    },
    startValue: {
      type: Number,
      default: 0
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showLoading: this.loading,
      countEndValue: 0,
      countStartValue: this.startValue,
      showDrawer: false,
      disabled: true,
      content: ''
    }
  },
  computed: {
  },
  watch: {
    loading: function(val) {
      this.showLoading = val
      if (this.showLoading) {
        this.refreshStat()
      }
    }
  },
  mounted() {
    window.addEventListener('resize', function(event) {
      // this.$refs.countTo.resize()
    })
  },
  methods: {
    refreshStat: function() {
      const _this = this
      this.showLoading = true
      this.$refs.countTo.start()

      request({ url: this.url, method: 'get' }).then(res => {
        const { data } = res.data
        this.countEndValue = data.total // || data
        this.$emit('onCompleteCallback', true)
        this.showLoading = false
      }).catch(() => {
        this.countEndValue = 0
        this.$Message.error({ content: '加载' + _this.subTitle + '失败', duration: 3 })
        this.$emit('onCompleteCallback', false)
        this.showLoading = false
      })

      // getStat(this.apiContextPath, {
      //   startDate: this.startDate,
      //   endDate: this.endDate,
      //   buildName: this.$store.getters.neSwId
      // }).then(res => {
      //   const { data } = res.data
      //   this.countEndValue = data.total // || data
      //   if (data.content) {
      //     this.disabled = false
      //     this.content = data.content.join(',')
      //   }
      //   this.$emit('onCompleteCallback', true)
      //   this.showLoading = false
      // }).catch(error => {
      //   console.log(error)
      //   this.countEndValue = 0
      //   this.$Message.error({ content: 'Failed to load stat data and please try again later.', duration: 3 })
      //   this.$emit('onCompleteCallback', false)
      //   this.showLoading = false
      // })
    }
  }
}
</script>
